import React from 'react';
import PropTypes from 'prop-types';
import { useAnalytics } from '@Shared/useAnalytics';
import {
  HeaderItemButton,
  HeaderItems
} from '@Header/HeaderMenu/HeaderMenu.styles';

const HeaderMenu = ({
  activeMenuName,
  shouldShowCarvanaFinancing,
  isLoggedIn,
  partner
}) => {
  const { trackEventAndGo, trackEvent } = useAnalytics();

  const handleMainNavClick = (ev, name) => {
    if (name === 'My Cars') {
      trackEvent('my_carvana_nav_link_tap');
    }
    trackEventAndGo(ev, 'clicked main nav link', {
      platform: 'desktop',
      link: name,
      partner: partner?.partnerVanityUrlName
    });
  };

  return (
    <HeaderItems>
      <HeaderItemButton
        dataCvTest="headerSearchLink"
        href="/cars"
        target="_self"
        isActive={activeMenuName === 'search' || activeMenuName === 'cars'}
        onClick={e => handleMainNavClick(e, 'Search Cars')}
      >
        Search Cars
      </HeaderItemButton>
      <HeaderItemButton
        dataCvTest="headerTradesLink"
        href="/sell-my-car"
        target="_self"
        isActive={activeMenuName === 'trades'}
        onClick={e => handleMainNavClick(e, 'Sell/Trade')}
      >
        Sell/Trade
      </HeaderItemButton>
      {shouldShowCarvanaFinancing ? (
        <HeaderItemButton
          dataCvTest="headerFinanceLink"
          href="/financing"
          target="_self"
          isActive={activeMenuName === 'finance'}
          onClick={e => handleMainNavClick(e, 'Financing')}
        >
          Financing
        </HeaderItemButton>
      ) : (
        <HeaderItemButton
          dataCvTest="headerFinancePartnerLink"
          href="/learn-financing"
          target="_self"
          isActive={activeMenuName === 'finance'}
          onClick={e => handleMainNavClick(e, 'Financing')}
        >
          Financing
        </HeaderItemButton>
      )}
      {isLoggedIn &&
        <HeaderItemButton
          dataCvTest="headerMyCarvanaLink"
          href="/my-carvana"
          target="_self"
          isActive={activeMenuName === 'myCarvana'}
          onClick={e => handleMainNavClick(e, 'My Cars')}
        >
          My Cars
        </HeaderItemButton>
      }
    </HeaderItems>
  );
};

HeaderMenu.defaultProps = {
  partner: {
    partnerVanityUrlName: 'notused'
  },
  activeMenuName: null,
  shouldShowCarvanaFinancing: true,
  isLoggedIn: false,
};

HeaderMenu.propTypes = {
  partner: PropTypes.shape({}),
  activeMenuName: PropTypes.string,
  shouldShowCarvanaFinancing: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

export default HeaderMenu;
